import type React from 'react';
import type { MultiSelectOption } from '../../../components/SearchableMultiSelect';
import type { SiteFilterRegion } from '@/domain/library';
import type { SavedViewsPrefs } from '../../../hooks/useSavedViews';
import type { WarehouseTabKey } from './warehouseTabs';

/** What every Warehouse tab receives from the page shell. */
export type WarehouseTabContext = {
  /** The tab strip, drawn between the hero and the toolbar. */
  tabStrip: React.ReactNode;
  /** The tabpanel the strip controls, and the id of each tab element that labels it. */
  panelId: string;
  tabElementId: (tab: WarehouseTabKey) => string;
  prefs: SavedViewsPrefs;
  prefsLoaded: boolean;
  profileId: string | null;
  /** ≤640px: phone hero and record cards. */
  isPhone: boolean;
  /** ≤720px: the filter sheet replaces the inline filters. */
  compactToolbar: boolean;
  siteOptions: MultiSelectOption[];
  /** The site option ids once the sites have loaded (null before), for dropping stale stored picks. */
  siteOptionIds: ReadonlySet<string> | null;
  regionFilterOptions: SiteFilterRegion[];
  /** From `?eventId=` (event "Transfers" links); filters on the server. */
  linkedEvent: { id: string; code: string | null } | null;
  onClearLinkedEvent: () => void;
};

export const WAREHOUSE_PAGE_SIZE = 50;
